import { Component, Inject } from '@angular/core';
import { Complaint, ComplaintPosition, DocumentAttachment } from '@icc/b2b/shared';
import { DIALOG_DATA, DialogRef } from '@icc/ui';

@Component({
    selector: 'icc-complaint-position-dialog',
    templateUrl: './complaint-position-dialog.component.html',
    styleUrls: ['./complaint-position-dialog.component.scss'],
})
export class ComplaintPositionDialogComponent {

    constructor(
        private dialogRef: DialogRef,
        @Inject(DIALOG_DATA)
        public data: {
            position: ComplaintPosition;
            complaint: Complaint;
            attachments: DocumentAttachment[];
        },
    ) {}

    async save() {
        this.dialogRef.close({
            position: this.data.position,
            attachments: this.data.attachments,
        });
    }

    close() {
        this.dialogRef.close();
    }
}
